// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

import getVue from '@/assets/js/getVue'
Vue.prototype.$getVue = getVue;

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$http = axios

// 公共js
import utils from "./assets/js/utils.js";
Vue.prototype.$utils = utils
// import VConsole from 'vconsole'
// new VConsole()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js